
class exports.Sidebar extends Handler

    init: () ->
        @layoutUrl = 'backend/portal/weightings/load-layout'

        @subHandlers =
            'WeightSets':
                'class': 'portal::handlers/weightings/WeightSetsTab'
            'Population':
                'class': 'portal::handlers/weightings/PopulationTab'

        @defaultSubHandler = 'WeightSets'

        @loadLayout()

    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            return

        self = this
        sidebar = $(@layoutSelector)

        if not response.status?
            sidebar.html(response)
            return

        # placement program dropdowns
        sidebar.find('.sel-pp').on 'change', () ->
            sidebar.find('.sel-pp').not(this).val $(this).val()

        sub = @createSubHandler @defaultSubHandler
        if sub
            sub.init()
